import axios from "axios";
import baseURL from "../configs/api";

export const delete_DeleteBulkVehicleClassAdditionalCharge = (ids: number[], userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}vehicleClassAdditionalCharge/DeleteBulkVehicleClassAdditionalCharge?userId=${userId}`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        data: ids
    }).then(response => response.data);
}

export const getVehicleClassAdditionalChargesByAdditionalChargeId = (additionalChargeId: number, tenantId: string) => {
    return getFetch(`vehicleClassAdditionalCharge/GetVehicleClassAdditionalChargesByAdditionalChargeId/${additionalChargeId}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}